import styled, { css } from 'styled-components';

import { CommonClickAction, VerticalHorizontalCenterColumnBlock } from '../../../styled';

const activeCardStyles = css`
  background-color: ${(props) => props.theme.colors.action}0a;
  box-shadow: 0 0 0 2px ${(props) => props.theme.colors.action};
`;

const disableCardStyles = css`
  :hover {
    cursor: default;
    background-color: ${(props) => props.theme.colors.tableCell};
  }

  svg path {
    fill: #a0abb8;
  }
  > * {
    color: #a0abb8;
  }
`;

const clickActionStyles = css`
  :active {
    ${CommonClickAction}
  }
`;

export const CardFrame = styled(VerticalHorizontalCenterColumnBlock)<{
  active?: boolean;
  disabled: boolean;
}>`
  ${(props) => !props.disabled && clickActionStyles};
  padding: 16px 5px;
  border-radius: 6px;
  box-shadow: 0 0 0 1px ${(props) => props.theme.colors.stroke};
  background-color: ${(props) => props.theme.colors.tableCell};

  :hover {
    cursor: pointer;
    background-color: rgba(0, 199, 126, 0.1);
  }

  ${(props) => props.active && activeCardStyles};

  ${(props) => props.disabled && disableCardStyles};
`;

export const CardIconWrapper = styled.div`
  margin-bottom: 16px;
`;

export const CardLabel = styled.div`
  ${(props) => props.theme.typography.subHeader3compact};
`;
